// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"CourseFeedbackModal_headerContainer__pubww","desc":"CourseFeedbackModal_desc__UebUq"};